import React, { Component } from 'react';
import { Router, IndexRoute, Route } from 'react-router';
import LinkedStateMixin from 'react-addons-linked-state-mixin';

import Immutable from 'immutable';
import {firebaseRoot} from '../../utils/firebase-utils';
import TouchLink from '../../components/TouchLink';
import ReactFireMixin from 'reactfire';
import 'react-tap-event-plugin';

import TouchButton from '../TouchButton';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import Input from 'react-bootstrap/lib/Input';
import LoginNav from '../LoginNav/LoginNav';
import SignupHeader from '../../components/SignupHeader/SignupHeader';

const HeaderContent = React.createClass({
    mixins: [
        LinkedStateMixin,
        ReactFireMixin
    ],

    getInitialState() {
        return {
            type: 'default',
            searchTerm: '',
            showResult: false,
            submitSupportDisabled: false
        };
    },

    submitForm() {
        if(!this.state.submitSupportDisabled) {
            this.setState({submitSupportDisabled: true});
            this.props.submitSupport();
        }
    },

    cancelSearch() {
        this.setState({
            showResult: false,
            searchTerm: ''
        });
    },

    render() {
        let type = this.props.type || null;

        if (type === 'exercise') {
            const calculatorTooltip = (<Tooltip id="calculator">Calculator allowed</Tooltip>);
            let calculatorModule = null;
            if (this.props.exercise.calculator) {
                calculatorModule = (
                    <div className="calculator-wrap">
                        <OverlayTrigger placement="left" overlay={calculatorTooltip}>
                            <div className="calculator"></div>
                        </OverlayTrigger>
                    </div>
                );
            }

            return (
                <div className="exercise-head-wrap">
                    <div className="exercise-head">
                        <h1 className="header">{this.props.exercise.name}</h1>
                        <span className="meta">Difficulty: {this.props.exercise.difficulty}</span>
                    </div>

                    <div className="header-tools">
                        {calculatorModule}
                        <TouchButton bsStyle="link" className="search">
                            <Glyphicon glyph="search"/>
                        </TouchButton>
                    </div>
                </div>
            );
        } else if (type === 'lesson') {
            return (
                <div className="lesson-head-wrap">
                    <div className="lesson-head">
                        <h1 className="header">Lesson {this.props.lessonId}</h1>
                    </div>
                    <div className="header-tools">
                        <TouchButton bsStyle="link" className="share"><Glyphicon glyph="share"/></TouchButton>
                        <TouchButton bsStyle="link" className="like"><Glyphicon glyph="star-empty"/></TouchButton>
                    </div>
                </div>
            );
        } else if (type === 'support') {


            let button = null;
            if(this.state.submitSupportDisabled) {
                button = <TouchButton bsStyle="link" onClick={this.submitForm} disabled>Skicka</TouchButton>
            } else {
                button = <TouchButton bsStyle="link" onClick={this.submitForm}>Skicka</TouchButton>
            }

            return (
                <div className="mobile-header-content">
                    <span className="mobile-header-title">{this.props.title}</span>
                    {button}
                </div>
            );
        } else if (type === 'login' || type === 'signup') {
            return (
                <LoginNav active={this.props.type} title={this.props.title}/>
            );
        } else if (type === 'signupSteps') {
            return (
                <SignupHeader step={this.props.step} title={this.props.title}/>
            );
        } else if(type === 'dashboard') {

            const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const header = document.querySelectorAll(".mobile-header-wrap");
            let headerHeight;
            let searchResultHeight = 0;
            if(header.length > 0) {
                headerHeight = header[0].offsetHeight;
                searchResultHeight = h - headerHeight;
            }

            let showResult = false;
            if(this.state.searchTerm) {
                showResult = true;
            }

            return (
                <div className="dashboard-search">
                    <div className="dashboard-search-field">
                        <div className="dashboard-search-input-wrap">
                            <Glyphicon glyph="search"/>
                            <input
                                className="search-field-input"
                                type="search"
                                placeholder="Sök efter uppgifter och lektioner"
                                valueLink={this.linkState('searchTerm')}
                            />
                        </div>
                        <TouchButton onClick={this.cancelSearch} className={`search-cancel ${this.state.searchTerm && 'js-show'}`} bsStyle="link">Cancel</TouchButton>
                    </div>
                    <div className={`dashboard-search-result ${showResult && this.state.searchTerm && 'js-show'}`} style={{height: searchResultHeight, top: headerHeight}}>
                        <div className="search-result-section">
                            <div className="search-result-header">Recommended assessment</div>
                            <ul className="search-result-list">
                                <li className="result-list-item">
                                    <TouchLink className="result-link" to="/">
                                        <div className="result-img"></div>
                                        <div className="result-details">
                                            <div className="result-header">Expanded Notation</div>
                                            <span className="result-meta">Exercise 101</span>
                                        </div>
                                    </TouchLink>
                                </li>
                                <li className="result-list-item">
                                    <TouchLink className="result-link" to="/">
                                        <div className="result-img"></div>
                                        <div className="result-details">
                                            <div className="result-header">Expanded Notation</div>
                                            <span className="result-meta">Exercise 101</span>
                                        </div>
                                    </TouchLink>
                                </li>
                            </ul>
                        </div>

                        <div className="search-result-section">
                            <div className="search-result-header">Lesson chapters</div>
                            <ul className="search-result-list">
                                <li className="result-list-item">
                                    <TouchLink className="result-link" to="/">
                                        <div className="result-img"></div>
                                        <div className="result-details">
                                            <div className="result-header">Expanded Notation</div>
                                        </div>
                                    </TouchLink>
                                </li>
                                <li className="result-list-item">
                                    <TouchLink className="result-link" to="/">
                                        <div className="result-img"></div>
                                        <div className="result-details">
                                            <div className="result-header">Expanded Notation</div>
                                        </div>
                                    </TouchLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="mobile-header-content">
                    <span className="mobile-header-title">{this.props.title}</span>
                    <div className="mobile-header-search">
                        <Input className="search-field hidden" type="search"/>
                        <Glyphicon glyph="search"/>
                    </div>
                </div>
            );
        }
    }
});


const MobileHeader = React.createClass({
    mixins: [ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    signOut() {
        this.context.history.pushState(null, '/', null);
        firebaseRoot.unauth();
    },

    render() {
        return (
            <div className="mobile-header-wrap">
                <header className="mobile-header">
                    <TouchButton bsStyle="link" onClick={this.context.history.goBack}
                                 className={this.props.backButton ? "mobile-header-backArrow js-show" : "mobile-header-backArrow js-hide"}>
                        <Glyphicon glyph="menu-left"/>
                    </TouchButton>
                    <HeaderContent
                        {...this.props}
                    />
                </header>
            </div>
        );
    }
});

export default MobileHeader;


/** WEBPACK FOOTER **
 ** ./src/components/MobileHeader/MobileHeader.js
 **/